function FormatMoneyFilter() {
  return function(value, nosymbol) {
    if (typeof value == 'undefined') {
      return '';
    }
    let n = (value / 100).toFixed(2);
    return nosymbol ? n : `$ ${n}`;
  };
}

export default FormatMoneyFilter;
